<template>
  <div class="aansluitingen pt-12">
    <v-container fluid class="grey darken-3 recolor" py-0 :class="[$vuetify.breakpoint.mdAndUp ? '' : '']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? 'px-8' : 'px-0 pb-0']">
        <v-layout
          align-center
          fill-height
          row 
          wrap
          :class="[$vuetify.breakpoint.mdAndUp ? 'pt-12 mt-8' : '']"
        >
          <v-flex xs12 class="d-flex h-100">
            <v-container fluid :class="[$vuetify.breakpoint.mdAndUp ? '' : 'pb-2']">
              <v-layout row wrap align-stretch :class="[$vuetify.breakpoint.mdAndUp ? 'py-6' : 'pt-6 pb-0']">
                <v-flex  xs12 md6 lg8 ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'pr-8 ' : 'mb-10']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'px-4 py-5', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 lg6 :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                          <div class="d-flex align-content-space-between flex-wrap fill-height">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">Storingstatus</span>
                                    <v-card height="100%" color="transparent" class="elevation-0" v-if="$vuetify.breakpoint.mdAndDown">
                                      <v-container fluid px-0>
                                        <v-row align="center">
                                          <v-col class="d-flex pb-0" cols="12" sm="6">
                                            <v-select
                                              :items="dataStatus"
                                              item-text="day"
                                              label="Maak een keuze"
                                              v-model="defaultSelected"
                                            ></v-select>
                                          </v-col>
                                        </v-row>
                                      </v-container>          
                                    </v-card>
                                   <v-card height="100%" color="transparent" class="elevation-0" v-if="$vuetify.breakpoint.lgAndUp">
                                    <v-container fluid fill-height pt-4 pb-2>
                                      <v-layout row wrap justify-end >
                                        <v-flex xs12 md12  py-0  class=" white--text position-relative">
                                          <v-container fluid py-0>
                                            <v-layout row wrap>
                                              <v-flex xs12 pr-2>
                                                <v-item-group mandatory v-model="dataStatusModel" class="">
                                                  <v-container fluid class="">
                                                    <div v-if="stateLoading"><span class="d-block"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                                                    <v-row v-if="!stateLoading">
                                                      <v-col
                                                        v-for="(item, i) in dataStatus"
                                                        :key="i"
                                                        cols="12"
                                                        md="12"
                                                        class="pa-0"
                                                      >
                                                        <v-item v-slot:default="{ active, toggle }">
                                                          <v-hover v-slot:default="{ hover }">
                                                          <v-card
                                                            :color="active ? 'grey darken-3 recolor' : ''"
                                                            class="d-flex align-center energy-dates"
                                                            dark
                                                            height="40"
                                                            @click="toggle(); selected(i);"
                                                            tile
                                                            :elevation="hover ? 2 : 0"
                                                            :class="{ 'on-hover': hover }"
                                                          > 
                                                            <v-container fluid grid-list-lg>
                                                              <v-layout row wrap align-center justify-end fill-height :class="['weekday-'+i]">
                                                                <v-flex xs12 sm6>
                                                                   {{ toShortFullDate(item.date) }}
                                                                </v-flex>
                                                                <v-flex xs12 sm6>
                                                                  <v-card height="20" class="elevation-0 tile head-graph ma-0" color="transparent" :class="[$vuetify.breakpoint.xsOnly ? 'pl-1' : '']">
                                                                    <bars-chart v-bind:data="item" style="border: 1px solid white; border-radius: 4px !important; padding: 2px;" class=""></bars-chart>
                                                                  </v-card>
                                                                </v-flex>
                                                              </v-layout>
                                                            </v-container>
                                                            <v-scroll-y-transition class="position-absolute">
                                                              <div
                                                                v-if="active"
                                                                class=" flex-grow-1 h-100 text-center position-relative "
                                                                :class="[$vuetify.breakpoint.xlOnly ? 'has-triangle triangle1 tri-small' : '']"
                                                              ></div>
                                                            </v-scroll-y-transition>
                                                          </v-card>
                                                          </v-hover>
                                                        </v-item>
                                                      </v-col>
                                                    </v-row>
                                                  </v-container>
                                                </v-item-group>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                          <v-container fluid py-0 px-3  :class="[$vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '']">
                                            <v-layout row wrap  justify-end :class="[$vuetify.breakpoint.mdAndDown ? 'px-2' : 'pr-1', $vuetify.breakpoint.lgAndUp ? '' : '']" >
                                              <v-flex xs12    class=" white--text position-relative">
                                                <v-container fluid py-0 px-5>
                                                  <v-layout row wrap  pr-1 fill-height >
                                                    <v-flex xs6 sm5>
                                                      <a class="d-block dashboard-pager can-press" @click="switchWeek(-1)">< vorige week</a>
                                                    </v-flex>
                                                    <v-flex xs6 sm7>
                                                      <v-layout row wrap justify-end pr-4>
                                                        <a class="d-block dashboard-pager" v-bind:class="{ 'can-press': date.getFullYear() + date.getMonth() + date.getDate() != today.getFullYear() + today.getMonth() + today.getDate() }" @click="switchWeek(1)">volgende week ></a>
                                                      </v-layout>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-container>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container> 
                          </div>
                        </v-flex>
                        <div v-if="stateLoading"></div>
                        <v-flex xs12 lg6 :class="[$vuetify.breakpoint.xlOnly ? 'pl-5' : '']" v-if="!stateLoading">
                          <v-card  class="elevation-0 mb-2 grey darken-3 recolor px-2 pb-3">
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.analyze) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'Storing bekend en wordt geanalyseerd'}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.states.analyze }} Storing bekend en wordt geanalyseerd
                                            </span>
                                            <v-icon class="ml-auto " >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.contacted) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-3">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'klant is benaderd'}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.states.contacted }} klant is benaderd
                                              </span>
                                              <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.help) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'Hulp nodig van lev/oda voor het maken klantafspraak'}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.states.help }} Hulp nodig van lev/oda voor het maken klantafspraak
                                              </span>
                                              <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                          <v-card class=" elevation-0 mb-2 grey darken-3 recolor px-2 pb-3">
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half orange d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.confirmed) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'Afspraak bevestigd'}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.states.confirmed }}  Afspraak bevestigd
                                              </span>
                                              <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half orange d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.checked) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'Oplossing wordt gecontroleerd'}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.states.checked }}  Oplossing wordt gecontroleerd
                                              </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                          <v-card  class=" elevation-0 grey darken-3 recolor px-2 pb-3">
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-pos1 d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.states.solved) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height >
                                            <a class="w-100 d-flex stat-link" @click="filter({current_state:'opgelost'}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.states.solved }}  opgelost
                                              </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex  xs12 md6 lg4  ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? ' ' : 'mb-8']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'px-4 py-5', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                          <div class="d-flex ">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">Status per netbeheerder</span>
                                    <v-item-group mandatory class="">
                                      <v-container fluid py-6 class="">
                                        <div v-if="operatorLoading"><span class="d-block mt-2"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                                        <v-row class="" v-if="!operatorLoading">
                                          <v-col
                                            v-for="(item, i) in netbeheerderStatus"
                                            :key="i"
                                            cols="12"
                                            md="12"
                                            class="pa-0"
                                          >
                                            <v-item v-slot:default="{ active, toggle }">
                                              <v-hover v-slot:default="{ hover }">
                                              <v-card
                                                :color="active ? 'grey darken-3 recolor' : ''"
                                                class="d-flex align-center energy-dates pa-0"
                                                dark
                                                :height="$vuetify.breakpoint.xsOnly ? 'auto' : '40'"
                                                @click="toggle"
                                                tile
                                                :elevation="hover ? 2 : 0"
                                                :class="{ 'on-hover': hover }"
                                              > 
                                                <v-container fluid grid-list-lg :class="[$vuetify.breakpoint.smAndDown ? 'px-2' : '']">
                                                  <v-layout row wrap align-center justify-end fill-height :class="['weekday-'+i]">
                                                    <v-flex xs12 sm6 justify-start class="text-left" :class="[$vuetify.breakpoint.smAndUp ? ' ' : 'py-0']">
                                                      <span>{{ item.operator.name }}</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                      <v-card height="20" class="elevation-0 tile head-graph ma-0 d-flex pr-5" color="transparent" :class="[$vuetify.breakpoint.xsOnly ? 'pl-1 ' : '']" @click="filter({operator:item.operator.id}, true)">
                                                        <bars-chart v-bind:data="item" style="border: 1px solid white; border-radius: 4px !important; padding: 2px;" class=""></bars-chart>
                                                        <v-icon class="small-icon pl-2">fas fa-chevron-right</v-icon>
                                                      </v-card>

                                                    </v-flex>

                                                  </v-layout>
                                                </v-container>
                                                <v-scroll-y-transition class="position-absolute">
                                                  <div
                                                    v-if="active"
                                                    class=" flex-grow-1 h-100 text-center position-relative "
                                                  ></div>
                                                </v-scroll-y-transition>
                                              </v-card>
                                              </v-hover>
                                            </v-item>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-item-group>
                                </v-flex>
                              </v-layout>
                            </v-container> 
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout row wrap :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card>
              <v-card-title class="px-0 white--text">
                {{ pageContent.pageSub2 }}
                <v-btn @click="malfuncitonsFilter = true" icon small class="ml-2"> <v-icon>filter_list</v-icon> </v-btn>
              </v-card-title>
              <v-data-table dark
                :headers="headers"
                :items="malfunctions"
                :server-items-length="malfunctionsTotal"
                :options.sync="malfunctionsOptions"
                :items-per-page="25"
                :loading="loadingMalfunctions"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :class="[$vuetify.breakpoint.smAndUp ? 'white-borders' : 'mobile-table']"
                dense
                loading-text="laden..."
                no-results-text="geen storingen beschikbaar"
                no-data-text="geen storingen beschikbaar"
              >
                <template v-slot:item.confirmed_at="{ item }">
                 {{ item.confirmed_at == null ? '' : toShortDate(item.confirmed_at)}}
                </template>
                <template v-slot:item.ean="{ item }">
                  <span class="text-no-wrap w-100 d-block">
                    <a class="white--text no-dec d-flex" @click="toConnections({ean:item.ean})">
                      <span>{{ item.ean }}</span>
                      <v-spacer></v-spacer>
                      <v-icon class="ml-auto small-icon">fas fa-chevron-right</v-icon>
                    </a>
                  </span>
                </template>
                <template v-slot:item.updated_at="{ item }">
                 {{ item.updated_at == null ? '' : toShortDate(item.updated_at)}}
                </template>
                <template v-slot:item.operator="{ item }">
                  <span class="text-no-wrap d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']">
                    <a class="white--text no-dec mr-2">{{ item.operator }}</a>
                    <v-icon class="ml-auto small-icon" >fas fa-chevron-right</v-icon>
                  </span>
                </template>
                <template v-slot:item.current_state="{ item }">
                  <span class="text-no-wrap d-flex">
                    <span class="white--text no-dec mr-2"> 

                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="item.state_color"></div>
                      </div>
                      {{ item.current_state }}</span>
                  </span>
                </template>    
                <template v-slot:item.data_date="{ item }">
                  <span class="text-no-wrap d-flex" @click="toRequests({ean:item.ean})">
                    <span class="white--text no-dec mr-2"> 
                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="item.data_state"></div>
                      </div>
                      {{ item.data_date == '?' ? item.data_date : toShortDate(item.data_date) }}</span>
                     <v-icon class="ml-auto small-icon cursor-pointer" >fas fa-chevron-right</v-icon>
                  </span>
                </template>
                <template v-slot:item.operator="{ item }">
                  <span class="text-no-wrap w-100 d-block" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']">
                    <a class="white--text no-dec d-flex" @click="selectdOperator(item)">
                        <span>{{ item.operator.name }}</span>
                        <v-spacer></v-spacer>
                        <v-icon class="ml-auto small-icon" v-if="item.operator.name != ''">fas fa-chevron-right</v-icon>
                      </a>
                  </span>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <filters title="Filter aanvragen" :open.sync="malfuncitonsFilter" :open="malfuncitonsFilter" :options="malfunciotnFilterOptions" :values="malfunctionsOptions.filters" @filter="filter"></filters>
   <operator :operator="selectedOperator" v-bind:dialog.sync="operatorDialog"></operator>
  </div>
</template>

<script>

import PieChart from '@/components/PieChart';
import BarsChart from '@/components/BarsChart';
import Operator from '@/components/Operator';
import Filters from '@/components/Filters';

export default {

  name: 'aansluitingen',
  components: { PieChart, BarsChart, Operator, Filters },
  data() {
    return {
      malfuncitonsFilter:false,
      current: true,
      stateLoading: false,
      dataStatusModel: 6,
      selectedDataStatus:{date: "", total:1, states:{analyze: 0, contacted: 0, help: 0, confirmed: 0, checked: 0, solved: 0}},
      dataStatus:[],
      netbeheerderStatus: [ ],
      operatorLoading: true,
      selectedOperator:{},
      operatorDialog: false,
      pagination: {
        rowsPerPage: 20
      },
      malfunciotnFilterOptions:
      {
        postal:{type:'text', label:'Postcode', placeholder:'1234AB'},
        number:{type:'text', label:'huisnummer', placeholder:'1'},
        ean:{type:'text', label:'ean', placeholder:'123456789012345678'},
        type:{type:'select', label:'type', options:[{ text: 'allemaal', value: null}, { text: 'elektriciteit', value: 1}, { text: 'gas', value: 3}, { text: 'teruglevering', value: 2}]},
        operator:{type:'select', label:'netbeheerder', options:this.$store.state.operators},
        current_state:{type:'text', label:'storing', placeholder:'opgelost'},
        confirmed_at:{type:'date', label:'start'},
        updated_at:{type:'date', label:'laatst gewijzigd'},
      },
      headers: [
        { text: 'Postcode', value: 'postal', align: 'left',},
        { text: 'Huisnr', value: 'number', align: 'left',},
        { text: 'EAN', value: 'ean', align: 'left',},
        { text: 'Type', value: 'type', align: 'left',},
        { text: 'Netbeheerder', value: 'operator', align: 'left',},
        { text: 'Storing', value: 'current_state', align: 'left',},
        { text: 'Start', value: 'confirmed_at', align: 'left',},
        { text: 'Laatst gewijzigd', value: 'updated_at', align: 'left',},
        { text: 'Laatste data', value: 'data_date', align: 'left', sortable:false,},
      ],
      malfunctions: [
      ],
      snackbar: false,
      text: 'Succesvol opgeslagen',
      color: 'primary',
      icon: 'check_circle',
      timeout: 3000,
      connectionAmount:0,
      chips: [],
      loadingMalfunctions: true,
      malfunctionsTotal:0,
      search:[],
      pageContent: {
        pageTitle: 'Aansluiting overzicht',
        pageSub1: 'Alle aansluitingen',
        pageSub2: 'Storingen',
      },
      date: new Date(),
      today:  new Date(),
    companies:[],
      operators: [ ],

    };
  },
  mounted()
  {
    this.loadStates();
  },
  methods: {
    switchWeek(direction)
    {
      this.date.setDate(this.date.getDate() + (7 * direction));
      this.loadStates();
    },
    filter(filters, scrollTo)
    {
      let temp = JSON.parse(JSON.stringify(this.malfunctionsOptions));
      temp.filters = filters;
      temp.page = 1;
      this.malfunctionsOptions = JSON.parse(JSON.stringify(temp));
      if(scrollTo === true)
      {
        this.$vuetify.goTo('table');
      }
    },
    loadStates()
    {
      this.stateLoading = true;

      this.dataStatus = [];
      let start = new Date(this.date);
      let end = this.date;
      start.setDate(start.getDate() - 6);
      let data = 
      {
        start:start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate(),
        end:end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate(),
      };
      this.$store.dispatch('loadMalfunctionsState', data).then
      ((data) => {
        this.dataStatusModel = 6;
        this.dataStatus = data.data;
        this.stateLoading = false;
        this.selected(this.dataStatusModel);
      });
    },
    selected(selected)
    {
        this.selectedDataStatus = this.dataStatus[selected];
        this.selectedDataStatus.total = 
          this.selectedDataStatus.states.analyze +
          this.selectedDataStatus.states.contacted +
          this.selectedDataStatus.states.help +
          this.selectedDataStatus.states.confirmed +
          this.selectedDataStatus.states.checked +
          this.selectedDataStatus.states.solved;
      this.loadOperator(this.selectedDataStatus.date);
    },
    loadOperator(date)
    {
      this.operatorLoading = true;
      let data = {date:date};
      this.netbeheerderStatus = [];
      this.$store.dispatch('loadOperatorMalfunctions', data).then
      ((data) => {
        this.netbeheerderStatus = data.data;
        this.operatorLoading = false;
      });
    },
    loadMalfunctions()
    {
      
      this.loadingMalfunctions = true;
      this.$store.dispatch('loadMalfunctions', this.malfunctionsOptions).then
      ((data) => {
        this.malfunctionsTotal = data.recordsTotal;
        this.malfunctions = data.data;
        this.loadingMalfunctions = false;
      });
    },
    selectdOperator(operator)
    {
      this.selectedOperator = operator.operator;
      this.operatorDialog = true;
    },
  },
  computed: {
    malfunctionsOptions: {
        get: function()
        {
          return this.$store.state.malfunctionsOptions;
        },
        set: function(value)
        {
          this.$store.state.malfunctionsOptions = value;
        }
    },
    permissions : {
      get() {
        return this.$store.getters.permissions;
      }
    }
  },
  watch:
  {
    malfunctionsOptions: {
      deep:true,
          handler (newState, old) {
           this.loadMalfunctions();
      }
    }
	},

};

</script>

<style scoped>

.v-card.energy-dates {
    -moz-transition: all 200ms ease-in;
    -webkit-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
}

.v-card.energy-dates:not(.on-hover):not(.v-item--active){
  background: #141414;
 }

.v-card.v-card--link:before{
  background: none;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>